import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ma-commune',
  templateUrl: './ma-commune.component.html',
  styleUrls: ['./ma-commune.component.scss']
})
export class MaCommuneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
